import React, { useState } from 'react'
import { TagsEditorProps } from './TagsEditor.types'
import styles from './TagsEditor.module.scss'
import cl from 'classnames'
import { Tag } from '../Tag'
import { Input } from '../Input'

const TagsEditorComponent = (props: TagsEditorProps) => {
  const {
    editMode,
    tags,
    onChange
  } = props

  const tagsArr = tags ? tags.split(',') : []
  const [inputState, setInputState] = useState<string>('')

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const isKeyEnter = event.which === 13
    if (!isKeyEnter) return

    const newTag = inputState.trim()
    if (!newTag || !onChange) return

    onChange(tags ? `${tags},${newTag}` : newTag)
    setInputState('')
  }

  return (
    <div className={cl(styles.tagsContainer)}>
      {editMode && (
        <Input
          placeholder='Type in a tag, use enter to add the tag'
          onChange={value => setInputState(value)}
          value={inputState}
          onKeyDown={onKeyDown}
        />
      )}
      {tagsArr.map((tag, index) => (
        <Tag
          key={index}
          tag={tag.trim()}
          className={styles.tag}
          removable={editMode}
          onRemove={() => {
            if (!onChange) return
            const tagsArrClone = [...tagsArr]
            tagsArrClone.splice(index, 1)
            onChange(tagsArrClone.join())
          }}
        />
      ))}
    </div>
  )
}

const TagsEditor = TagsEditorComponent
export { TagsEditor }
